export default __webpack_public_path__ + "static/media/icon-cvv.3c40c5ce.svg";